"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttachedFileList = exports.AttachedFileListProvider = void 0;
const react_1 = require("react");
const AttachedFileListContext = (0, react_1.createContext)(undefined);
AttachedFileListContext.displayName = "AttachedFileListContext";
const AttachedFileListProvider = AttachedFileListContext.Provider;
exports.AttachedFileListProvider = AttachedFileListProvider;
const useAttachedFileList = () => {
    const context = (0, react_1.useContext)(AttachedFileListContext);
    if (context === undefined) {
        throw new Error("This component is an AttachedFileListConsumer, it must be used within an AttachedFileListProvider");
    }
    return context;
};
exports.useAttachedFileList = useAttachedFileList;
//# sourceMappingURL=AttachedFileListContext.js.map